var newDesign = false;
var toolTipClicked = false;

var RedesignABTestingJS = (function ($) {

    function addTooltipClickListener() {
        $("span[data-content-id='service-partner-legend-tyre-hotel-service-tooltip-container']").on('click', function() {
            var isMobile = window.matchMedia("only screen and (max-width: 767px)").matches;
            if(isMobile) {
                $("#overDiv").addClass("how-it-work-tooltip");
                toolTipClicked = true;
            }
        });
    }

    function displayServicePartnerResult() {
        if (newDesign) {
            $('#servicePartnerContent').remove();
            addChangeListener();
            ServicePartnerMap.initialize();
        } else {
            $('#servicePartnerContentRedesign').remove();
        }
    }

    function addChangeListener() {
        $("#service-partner-radius").on('change', function () {
            ServicePartnerAddOn.searchForServicePartners();
        });
    }

    function addActiveSelection() {
        var deliveryMethodLabels = $(".redesign.delivery-method label");
        deliveryMethodLabels.on('click', function(e) {
            deliveryMethodLabels.each(function (index, element) {
                $(element).removeClass('activeSelection');
            });
            $(this).addClass('activeSelection');
        });
        deliveryMethodLabels.each(function (index, element) {
            $(element).removeClass('activeSelection');
        });
        $(".j-delivery-method-radio-buttons input:checked").parent('label').addClass('activeSelection');

    }

    function showNewDesign() {
        $(".j-delivery-method-radio-buttons.checkout-step1 .delivery-method").addClass("redesign");
        $(".j-delivery-method-radio-buttons.delivery-method-radios .delivery-method").addClass("redesign");
        $(".service-partner-service-icon-description").addClass("redesign");
        addActiveSelection();
        addTooltipClickListener();
        $(".redesign").show();
        ServicePartnerMap.initialize();
        newDesign = true;
    }

    function showOldDesign() {
        $(".j-delivery-method-radio-buttons.checkout-step1 .delivery-method").removeClass("redesign");
        $(".j-delivery-method-radio-buttons.delivery-method-radios .delivery-method").removeClass("redesign");
        $(".service-partner-service-icon-description").removeClass("redesign");
        $(".redesign").hide();
        ServicePartnerMap.initialize();
        newDesign = false;
    }

    return {
        showNewDesign: showNewDesign,
        showOldDesign: showOldDesign,
        addActiveSelection: addActiveSelection,
        displayServicePartnerResult: displayServicePartnerResult
    }

})($);

